export class TwoWayMapping {
    constructor(map) {
       this.map = map;
       this.reverseMap = {};
       for(const key in map) {
          const value = map[key];
          this.reverseMap[value] = key;   
       }
    }
    getValue(key) { return this.map[key]; }
    getKey(key) { return this.reverseMap[key]; }
  }
  
  
  export const iconObjs = {
    "pe-7s-graph2": "ri-bar-chart-box-line",
    "pe-7s-timer": "ri-time-line",
    "pe-7s-repeat": "ri-repeat-line",
    "pe-7s-check": "ri-checkbox-circle-line",
    "pe-7s-graph": "ri-pie-chart-2-line",
    "pe-7s-pen": "ri-pencil-fill",
    "pe-7s-config": "ri-settings-5-line",
    "pe-7s-settings": "ri-tools-line",
    "pe-7s-album": "ri-music-2-line",
    "pe-7s-hammer": "ri-auction-line",
    "pe-7s-leaf": "ri-leaf-line",
    "pe-7s-arc": "ri-crosshair-2-line",
    "pe-7s-diamond": "ri-vip-diamond-line",
    "pe-7s-hourglass": "ri-hourglass-line",
    "pe-7s-door-lock": "ri-git-repository-private-line",
    "pe-7s-users": "ri-user-line",
    "pe-7s-cart": "ri-shopping-cart-line",
    "pe-7s-camera": "ri-camera-line",
    "pe-7s-call": "ri-phone-line",
    "pe-7s-date": "ri-calendar-line",
    "pe-7s-airplay": "ri-computer-line",
    "pe-7s-map": "ri-map-2-line",
    "pe-7s-mail": "ri-mail-line",
    "pe-7s-science": "ri-reactjs-line",
    "pe-7s-paperclip": "ri-attachment-line",
    "pe-7s-plane": "ri-flight-takeoff-line",
    "pe-7s-joy": "ri-gamepad-line",
    "pe-7s-id": "ri-bank-card-line",
    "pe-7s-news-paper": "ri-article-line",
    "pe-7s-microbiology": "ri-bug-line",
    "pe-7s-microbiology-2": "ri-bug-2-line",
    "pe-7s-virus": "ri-virus-line",
    "pe-7s-microscope": "ri-microscope-line"
  };
  
  export const IconMapping = new TwoWayMapping(iconObjs);
  
  export const iconColor = {
    inActive: "#000",
    active: "#0037ff",
  };
  